/**
 * SessionTimerDisplay - Session countdown timer with progress
 */
import React, { memo } from 'react';
import { Progress } from './ui/progress';

const SessionTimerDisplay = memo(({
  timeRemaining,
  duration,
  isActive,
  progress,
  formattedTime,
  formattedDuration,
  fadeEnabled = false,
  fadeMultiplier = 1
}) => {
  if (!isActive && timeRemaining === 0) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-lg p-3 border border-blue-400/30">
      {/* Timer Header */}
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <span className="text-xl">⏱️</span>
          <span className="text-white text-sm font-medium">Session Timer</span>
        </div>
        {fadeEnabled && fadeMultiplier < 1 && (
          <span className="text-xs text-blue-300">
            {fadeMultiplier < 0.5 ? '🔉 Fading...' : '🔊'}
          </span>
        )}
      </div>

      {/* Time Display */}
      <div className="text-center mb-2">
        <span className="text-3xl font-mono text-white font-bold">
          {formattedTime}
        </span>
        <span className="text-white/50 text-sm ml-2">
          / {formattedDuration}
        </span>
      </div>

      {/* Progress Bar */}
      <Progress 
        value={progress} 
        className="h-2 bg-white/10"
      />

      {/* Status */}
      <div className="flex justify-between mt-2 text-xs text-white/60">
        <span>{isActive ? '▶ Playing' : '⏸ Paused'}</span>
        <span>{Math.round(progress)}% complete</span>
      </div>
    </div>
  );
});

SessionTimerDisplay.displayName = 'SessionTimerDisplay';

export default SessionTimerDisplay;
